import type { ConversationPublic } from '@repo/types/chat';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { ChatService } from './chatService';
import { ChatKey } from './keys';
import { getLastConversationsInfiniteOptions } from './useGetLastConversationsInfinite';

export function useGetChat(id: number, enabled: boolean = true) {
  const queryClient = useQueryClient();

  const placeholderData = useMemo((): ConversationPublic | undefined => {
    const infiniteData = queryClient.getQueryData(getLastConversationsInfiniteOptions().queryKey);

    if (!infiniteData?.pages) {
      return undefined;
    }
    for (const page of infiniteData.pages) {
      const conversation = page.find((conv) => conv.id === id);
      if (conversation) {
        return conversation;
      }
    }

    return undefined;
  }, [queryClient, id]);

  const getChatQuery = useQuery({
    queryKey: [ChatKey.CHAT, id],
    queryFn: () => ChatService.getChat(id).then((response) => response.data),
    enabled: enabled,
  });

  const errorMessage = useErrorMessage(getChatQuery.error);

  return { ...getChatQuery, errorMessage, placeholderData };
}
